module.exports = __webpack_public_path__ + "static/media/ref.3c8f0490.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/ref.png
// module id = 87
// module chunks = 0